import { CheckIcon } from '@/assets/icons'
import InviteModal from '@components/InviteModal'
import { Trip } from '@types'
import React, { useState } from 'react'
import { CreateTripDraft } from './core/draft'
import { inviteTitle } from './core/presentation'
import {
	CheckCircle,
	CodeField,
	GoButton,
	InviteButton,
	ReadyCenter,
	ReadyLayout,
	ReadyTitle,
} from './ReadyStep.styles'
import { iconSizes } from '@/theme/tokens'
import { TestIds } from '@/testIds'

interface ReadyStepProps {
	trip: Trip
	draft: CreateTripDraft
	onGoToTrip: () => void
}

/**
 * Post-create success screen, laid out like iOS: the trip is real now — there
 * is no way back into the flow's steps. Joining is by trip code, so inviting
 * is sharing the code (the invite modal, or copying it). A doorway, not a
 * gate: going to the trip is the primary action.
 */
const ReadyStep: React.FC<ReadyStepProps> = ({ trip, draft, onGoToTrip }) => {
	const [isInviteOpen, setIsInviteOpen] = useState(false)

	return (
		<ReadyLayout>
			<ReadyCenter>
				<CheckCircle aria-hidden>
					<CheckIcon sx={{ fontSize: iconSizes.hero }} />
				</CheckCircle>
				<ReadyTitle>{inviteTitle(draft)}</ReadyTitle>
				<InviteButton type="button" onClick={() => setIsInviteOpen(true)}>
					Invite members
				</InviteButton>
				<CodeField
					caption="Trip code"
					value={trip.code}
					variant="code"
					errorMessage="Could not copy the code. Please copy it manually."
				/>
			</ReadyCenter>
			<GoButton type="button" onClick={onGoToTrip} data-testid={TestIds.tripCreate.goToTripButton}>
				Go to your trip
			</GoButton>

			<InviteModal isOpen={isInviteOpen} onClose={() => setIsInviteOpen(false)} tripCode={trip.code} />
		</ReadyLayout>
	)
}

export default ReadyStep
